import { Module } from "vuex";
import { RootState } from "../types";
import { whatsappStatistic } from "./statistic";

export const whatsappModule: Module<void, RootState> = {
  modules: {
    whatsappStatistic,
  },
};